import { render, staticRenderFns } from "./PdfClinicalHistory.vue?vue&type=template&id=3b687d22&scoped=true"
import script from "./PdfClinicalHistory.vue?vue&type=script&lang=js"
export * from "./PdfClinicalHistory.vue?vue&type=script&lang=js"
import style0 from "./PdfClinicalHistory.vue?vue&type=style&index=0&id=3b687d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b687d22",
  null
  
)

export default component.exports